import React from "react";
import { motion } from "framer-motion";
import Profile from "./Profile";
import Skills from "./Skills";
import ProfileTabs from "./ProfileTabs";
import Contact from "./Contact";
import "./Background.css";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

function Background() {
  return (
    <motion.div
      className="background"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.div className="content-wrapper" variants={itemVariants}>
        <motion.div className="card" variants={itemVariants}>
          <motion.div variants={itemVariants}>
            <Profile />
          </motion.div>
          <motion.div variants={itemVariants}>
            <ProfileTabs />
          </motion.div>
          <motion.div variants={itemVariants}>
            <Contact />
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}

export default Background;